import React from 'react'


const NotFound = () => (
  <article className="page article">
    <section className="content">
      <p className="text--center">
        Nothing here
      </p>
    </section>
  </article>
)


export default NotFound



// WEBPACK FOOTER //
// ./src/pages/NotFound.js